import React, { useRef } from 'react';

export interface FilterSelectOption {
  value: string;
  label: string;
}

export interface FilterSelectProps {
  label: string;
  value: string | null;
  options: FilterSelectOption[];
  onChange: (value: string | null) => void;
  placeholder?: string;
}

/**
 * FilterSelect — single-value dropdown.
 */
export default function FilterSelect({
  label,
  value,
  options,
  onChange,
  placeholder = 'Select…',
}: FilterSelectProps) {
  const selectRef = useRef<HTMLSelectElement>(null);

  return (
    <div className="min-h-[44px] flex flex-col gap-1">
      <label className="text-[10px] uppercase tracking-wide text-fg-muted font-semibold">
        {label}
      </label>
      <select
        ref={selectRef}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || null)}
        aria-label={`Filter by ${label}`}
        className="bg-bg-base border border-border-base rounded px-3 py-2 text-fg-primary text-sm focus:outline-none focus:ring-2 focus:ring-accent min-h-[40px]"
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
